import React, { useEffect, useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CropIcon from "@mui/icons-material/Crop";
import RefreshSharpIcon from "@mui/icons-material/RefreshSharp";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import { ReactComponent as FlipHSvg } from "@assets/images/FlipHSvg.svg";
import styled from "styled-components";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css"; // Import the CSS for react-cropper
import { Alert, Button, CircularProgress, Skeleton } from "@mui/material";
import { createGlobalStyle } from "styled-components";
import {
  base64ToFile,
  getBusinessBoxPath,
  getUserProfilePath,
  getWheelUploadPath,
  handleFileUpload,
} from "../../utils/fileUpload";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "../../utils/helpers";
import { getWheelId } from "../../redux/selectors/segmentBuilderSelectors";

const GlobalStyle = createGlobalStyle`
  .cropper-crop-box,
.cropper-view-box {
     border-radius: ${(props) => (props.circular ? "50%" : "0")};
     outline: ${(props) => (props.circular ? "none" : "2px dashed #2196F3")};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); 
  }
`;
const SelectedBox = styled.div`
  border: 1px solid #625b71;
  background: #fef7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 8px;
  gap: 6px;
`;

const OptionsWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin: 10px 0px;
`;

const OptionsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  border: 1px solid #cac4d0;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  background: ${(props) => (props.selected ? "#F7F2FA" : "white")};
`;

function ImageCropper({
  persistCrop = false,
  open,
  handleClose,
  src,
  handleEditImage,
  isWallpaperCropper = false,
  isWheelPortrait = false,
  lockedAspectRatio = null, // New prop for locked aspect ratio
  pathType,
}) {
  const [activeTool, setActiveTool] = useState("crop"); // Tracks the active tool
  const [selectedOption, setSelectedOption] = useState(null);
  const cropperRef = useRef(null);

  const [cropData, setCropData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // useEffect(() => {
  //   // When the modal opens, set the crop data if it exists
  //   if (open && cropData && cropperRef.current) {
  //     cropperRef.current.cropper.setData(cropData);
  //   }
  // }, [open, cropData]);

  // useEffect(() => {
  //   if (open) {
  //     setLoading(true); // Set loading state to true when modal opens
  //     setActiveTool("crop");
  //   }
  // }, [open]);

  useEffect(() => {
    if (!open) {
      setActiveTool("crop");
      // setSelectedOption(null);
      // setCropData({});
    }
  }, [open]);
  console.log(selectedOption, "andar", cropData);

  // Initialize cropper or set data when modal is opened
  useEffect(() => {
    if (open && cropperRef?.current && !_.isEmpty(cropData)) {
      setLoading(true);
      const cropper = cropperRef.current.cropper;
      cropper.reset();
      //if locked, set cropper ratio
      if (lockedAspectRatio) cropper.setAspectRatio(lockedAspectRatio);

      setTimeout(() => {
        cropper.setData(cropData);
      }, 100); // Delay setting data to ensure cropper is ready
    }
  }, [open, cropData]);

  useEffect(() => {
    let timer;

    if (open) {
      timer = setTimeout(() => {
        if (loading) {
          setErrorMessage("This image file is unable to be cropped.");
          setLoading(false);
          // handleClose();
        }
      }, 9000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open, loading]);

  const handleCloseEditImage = () => {
    setActiveTool(null);
    // setSelectedOption(null);
    handleClose();
  };

  const rotateImage = (direction) => {
    const cropper = cropperRef.current.cropper;
    if (direction === "CW") {
      cropper.rotate(90);
    } else {
      cropper.rotate(-90);
    }
  };

  const flipImage = (mode) => {
    const cropper = cropperRef.current.cropper;
    if (mode === "Horizontal") {
      cropper.scaleX(-cropper.getData().scaleX);
    } else {
      cropper.scaleY(-cropper.getData().scaleY);
    }
  };

  const wheelId = useSelector(getWheelId);
  const user_id = getLoggedInUser().id;

  const getUploadPath = () => {
    if (pathType === "profile") {
      return getUserProfilePath({ user_id });
    } else if (pathType === "bussinessBox") {
      return getBusinessBoxPath({ user_id });
    } else {
      return getWheelUploadPath({ user_id, wheel_id: wheelId });
    }
  };

  const handleApplyEditing = async () => {
    setUploading(true);
    const cropper = cropperRef.current.cropper;
    const croppedImageUrl = cropper.getCroppedCanvas().toDataURL();
    const file = base64ToFile(croppedImageUrl, "image");
    const { location } = await handleFileUpload(file, getUploadPath());
    handleEditImage(location);
    setCropData(cropper.getData());
    setUploading(false);
    handleCloseEditImage();
  };

  const handleToolClick = (tool) => {
    setActiveTool(activeTool === tool ? null : tool); // Toggle tool or switch tools
    // setSelectedOption(null);

    const cropper = cropperRef.current.cropper;
    if (tool === "crop" || isWallpaperCropper || isWheelPortrait) {
      cropper.setDragMode("crop");
      if (lockedAspectRatio) {
        cropper.setAspectRatio(lockedAspectRatio);
      } else {
        cropper.setAspectRatio(
          isWallpaperCropper ? 0.85 : isWheelPortrait ? 1 : NaN
        ); // Set aspect ratio for wallpaper cropper
      }
    } else {
      cropper.setDragMode("none"); // Disable drag when not in crop mode
      if (!persistCrop) {
        cropper.clear(); // Clear crop box when switching to rotate or flip
      }
    }
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    const cropper = cropperRef.current.cropper;

    switch (option) {
      case "Custom":
        cropper.setAspectRatio(NaN);
        break;
      case "1:1":
        cropper.setAspectRatio(1);
        break;
      case "3:2":
        cropper.setAspectRatio(3 / 2);
        break;
      case "5:4":
        cropper.setAspectRatio(5 / 4);
        break;
      case "16:9":
        cropper.setAspectRatio(16 / 9);
        break;
      case "90° CW":
        rotateImage("CW");
        break;
      case "90° CCW":
        rotateImage("CCW");
        break;
      case "Horizontal":
        flipImage("Horizontal");
        break;
      case "Vertical":
        flipImage("Vertical");
        break;
      default:
        break;
    }
  };

  const renderToolOptions = () => {
    let optionsContent;

    switch (activeTool) {
      case "crop":
        if (!isWallpaperCropper && !isWheelPortrait && !lockedAspectRatio) {
          const cropOptions = ["Custom", "1:1", "3:2", "5:4", "16:9"];
          optionsContent = cropOptions.map((option) => (
            <OptionsButton
              key={option}
              onClick={() => handleOptionClick(option)}
              selected={selectedOption === option}
            >
              {option}
            </OptionsButton>
          ));
        }
        break;
      case "rotate":
        const rotateOptions = [
          { label: "90°", direction: "CW" },
          { label: "90°", direction: "CCW" },
        ];
        optionsContent = rotateOptions.map((option) => {
          const labelName = option.label + " " + option.direction;
          return (
            <OptionsButton
              key={option.label + option.direction}
              onClick={() => handleOptionClick(labelName)}
              selected={selectedOption === labelName}
            >
              <RefreshSharpIcon
                sx={{
                  transform: option.direction === "CW" ? "scaleX(-1)" : "none",
                  color: "#625b71",
                }}
              />
              {option.label}
            </OptionsButton>
          );
        });
        break;
      case "flip":
        const flipOptions = ["Horizontal", "Vertical"];
        optionsContent = flipOptions.map((option) => (
          <OptionsButton
            key={option}
            onClick={() => handleOptionClick(option)}
            selected={selectedOption === option}
          >
            <FlipHSvg
              style={{
                fill: "#625b71",
                width: "24px",
                height: "24px",
                transform: option === "Vertical" ? "rotate(90deg)" : "none",
              }}
            />
            {option}
          </OptionsButton>
        ));
        break;
      default:
        optionsContent = null;
    }

    return optionsContent ? (
      <OptionsWrapper>{optionsContent}</OptionsWrapper>
    ) : null;
  };

  return (
    <>
      <GlobalStyle circular={isWheelPortrait} />
      <Modal open={open} onClose={handleCloseEditImage}>
        <Box
          sx={{
            position: "absolute",
            top: "20%",
            right: "2%",
            width: "489px",
            height: "auto",
            background: "#fff",
            boxShadow: 24,
            borderRadius: "8px",
            padding: "16px",
            outline: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <EditIcon sx={{ color: "#565556" }} />
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  fontFamily: "DM Sans",
                  color: "#565556",
                }}
              >
                Edit Image
              </Typography>
            </Box>
            <IconButton onClick={handleCloseEditImage}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <IconButton
              aria-label="crop"
              onClick={() => handleToolClick("crop")}
            >
              {activeTool === "crop" ? (
                <SelectedBox>
                  <CropIcon sx={{ color: "#625b71" }} />
                  <Typography sx={{ color: "#625b71" }}>Crop</Typography>
                </SelectedBox>
              ) : (
                <CropIcon sx={{ color: "black" }} />
              )}
            </IconButton>
            <IconButton
              aria-label="rotate"
              onClick={() => handleToolClick("rotate")}
            >
              {activeTool === "rotate" ? (
                <SelectedBox>
                  <RefreshSharpIcon
                    sx={{ transform: "scaleX(-1)", color: "#625b71" }}
                  />
                  <Typography sx={{ color: "#625b71" }}>Rotate</Typography>
                </SelectedBox>
              ) : (
                <RefreshSharpIcon
                  sx={{ transform: "scaleX(-1)", color: "black" }}
                />
              )}
            </IconButton>
            <IconButton
              aria-label="flip"
              onClick={() => handleToolClick("flip")}
            >
              {activeTool === "flip" ? (
                <SelectedBox>
                  <FlipHSvg
                    style={{ fill: "#625b71", width: "24px", height: "24px" }}
                  />
                  <Typography sx={{ color: "#625b71" }}>Flip</Typography>
                </SelectedBox>
              ) : (
                <FlipHSvg style={{ fill: "black" }} />
              )}
            </IconButton>
          </Box>

          {renderToolOptions()}

          {!errorMessage && (
            <Box sx={{ height: "294px", width: "100%" }}>
              {loading && (
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="100%"
                  animation="wave"
                  sx={{ backgroundColor: "#fef7ff" }}
                />
              )}
              <Cropper
                // key={selectedOption}
                src={src}
                style={{ height: "100%", width: "100%" }}
                aspectRatio={
                  lockedAspectRatio
                    ? lockedAspectRatio
                    : isWallpaperCropper
                    ? 0.85 // Aspect ratio for wallpaper cropper
                    : isWheelPortrait
                    ? 1
                    : activeTool === "crop"
                    ? selectedOption === "Custom"
                      ? NaN
                      : selectedOption === "1:1"
                      ? 1
                      : selectedOption === "3:2"
                      ? 3 / 2
                      : selectedOption === "5:4"
                      ? 5 / 4
                      : selectedOption === "16:9"
                      ? 16 / 9
                      : 1
                    : NaN
                }
                guides={false}
                ref={cropperRef}
                cropBoxResizable={true}
                background={false}
                modal={false}
                viewMode={2}
                highlight={true}
                data={cropData}
                ready={() => setLoading(false)}
                autoCrop={true} // Enable auto cropping
                autoCropArea={1} // Select entire image initially
                // autoCrop={activeTool === "crop"}
                // dragMode={activeTool === "crop" ? "crop" : "none"}
                // autoCropArea={activeTool === "crop" ? 1 : 0} // Control crop area based on tool
              />
            </Box>
          )}

          {errorMessage && (
            <Box sx={{ mt: 2 }}>
              <Alert severity="error">{errorMessage}</Alert>
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              sx={{
                borderRadius: "8px",
                border: "1px solid #cac4d0",
                boxShadow: " 0px 0px 9.3px 0px #3b3b3b1c",
                backgroundColor: "#F7F2FA",
                padding: "6px 30px",
                color: "#625b71",

                "&.Mui-disabled": {
                  backgroundColor: "lightgray",
                  color: "black",
                },
              }}
              disabled={
                errorMessage ||
                ((activeTool === "flip" || activeTool === "rotate") &&
                  !selectedOption)
              }
              onClick={handleApplyEditing}
            >
              {uploading ? <CircularProgress /> : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ImageCropper;
